var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper",
    {
      staticClass: "background",
      model: {
        value: _vm.e1,
        callback: function($$v) {
          _vm.e1 = $$v
        },
        expression: "e1"
      }
    },
    [
      [
        _c("modalError", { ref: "modalError" }),
        _c("modalAlert", { ref: "modalAlert" }),
        _c(
          "v-stepper-header",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.steps > 1,
                expression: "steps > 1"
              }
            ]
          },
          [
            _vm._l(_vm.steps, function(n) {
              return [
                _c(
                  "v-stepper-step",
                  {
                    key: n + "-step",
                    attrs: { complete: _vm.e1 > n, step: n }
                  },
                  [_vm.votesPerVoter > 1 ? _c("span") : _vm._e()]
                ),
                n !== _vm.steps ? _c("v-divider", { key: n }) : _vm._e()
              ]
            })
          ],
          2
        ),
        _c(
          "v-stepper-items",
          [
            _c("v-progress-linear", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.progressBar,
                  expression: "progressBar"
                }
              ],
              attrs: { slot: "progress", color: "blue", indeterminate: "" },
              slot: "progress"
            }),
            _c(
              "v-stepper-content",
              { staticClass: "rmv-padding", attrs: { step: _vm.confirmation } },
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c("v-col", { attrs: { cols: "12", sm: "12" } }, [
                      _vm.showVoteInfo
                        ? _c(
                            "span",
                            [
                              _c("br"),
                              _c("v-alert", { attrs: { type: "success" } }, [
                                _vm._v(" Seu voto foi realizado com sucesso. ")
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Eleição: " +
                                    _vm._s(_vm.$store.state.vote.electionName)
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Título: " +
                                    _vm._s(_vm.$store.state.vote.identifier)
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Nome: " + _vm._s(_vm.$store.state.vote.name)
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Data: " +
                                    _vm._s(_vm.$store.state.vote.votedOn)
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._l(_vm.steps, function(n) {
              return _c(
                "v-stepper-content",
                {
                  key: n + "-content",
                  staticClass: "rmv-padding pl-0 pr-0",
                  attrs: { step: n }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c("v-flex", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.candidateRolesCurrent
                                ? _vm.candidateRolesCurrent.name
                                : ""
                            )
                          )
                        ])
                      ]),
                      _c(
                        "v-flex",
                        {
                          staticClass:
                            "d-flex flex-column justify-center align-center"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "candidate_vote d-flex justify-center align-start"
                            },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  model: {
                                    value: _vm.candidateIndex,
                                    callback: function($$v) {
                                      _vm.candidateIndex = $$v
                                    },
                                    expression: "candidateIndex"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column candidate-group"
                                    },
                                    _vm._l(_vm.candidateCurrentList, function(
                                      item,
                                      i
                                    ) {
                                      return _c("v-radio", {
                                        key: i,
                                        ref: "vradio_y",
                                        refInFor: true,
                                        staticClass:
                                          "d-flex flex-row candidate-list",
                                        on: {
                                          change: function($event) {
                                            return _vm.vRadioChange(i)
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      key: item.number,
                                                      ref: "divCandidate",
                                                      refInFor: true,
                                                      staticClass:
                                                        "d-flex flex-row align-items-stretch canditate-item",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.listItemEvent(
                                                            i
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex candidate-img"
                                                        },
                                                        [
                                                          _c("v-img", {
                                                            attrs: {
                                                              width:
                                                                _vm.img.value
                                                                  .width,
                                                              height:
                                                                _vm.img.value
                                                                  .height,
                                                              src: item.picture
                                                                ? item.picture
                                                                : item.nickname ==
                                                                  "Voto Nulo"
                                                                ? _vm.imgNulo
                                                                : _vm.imgBranco,
                                                              "aspect-ratio":
                                                                "1.0"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-column align-items-center justify-center px-2 candidate-info"
                                                        },
                                                        [
                                                          _c("div", {
                                                            class:
                                                              _vm.objClass
                                                                .value,
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                item.number ==
                                                                  "-1" ||
                                                                  item.number ==
                                                                    "-2"
                                                                  ? ""
                                                                  : item.number
                                                              )
                                                            }
                                                          }),
                                                          _c("div", {
                                                            class:
                                                              _vm.objClass
                                                                .value,
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                item.nickname
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    }),
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "urna_teclado mt-8" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-row justify-center align-start teclas_acao teclas_acao_mosaic"
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "tertiary--text mr-2",
                                    attrs: { color: "error" },
                                    on: { click: _vm.clearCandidate }
                                  },
                                  [_vm._v(" Corrige ")]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "tertiary--text",
                                    attrs: {
                                      color: "success",
                                      disabled: !_vm.isAllowedToContinue
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.nextStep(n)
                                      }
                                    }
                                  },
                                  [_vm._v(" Confirma ")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            })
          ],
          2
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }